
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Dialog from "@/components/UI/Dialog.vue";
import { configStore } from "@/store/store-accessor";

@Component({
  components: { Dialog }
})
export default class InvalidPostDialog extends Vue {
  get invalidPostData() {
    return configStore.invalidPostData;
  }
}
